import GoogleFontLoader from './GoogleFontLoader';

export default GoogleFontLoader;
